import { render, staticRenderFns } from "./fundProjectList.vue?vue&type=template&id=54655fee&scoped=true&"
import script from "./fundProjectList.vue?vue&type=script&lang=ts&"
export * from "./fundProjectList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54655fee",
  null
  
)

export default component.exports